import { render, staticRenderFns } from "./SubProcessDesign.vue?vue&type=template&id=6b0c6246&scoped=true"
import script from "./SubProcessDesign.vue?vue&type=script&lang=js"
export * from "./SubProcessDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c6246",
  null
  
)

export default component.exports